
import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface JobOffer {
  id: string;
  title: string;
  location: string;
  contract_type: string;
  experience_level: string;
  department: string;
  description: string;
  requirements: string[];
  is_active: boolean;
  display_order: number;
}

export const useJobOffers = () => {
  return useQuery({
    queryKey: ['job-offers'],
    queryFn: async (): Promise<JobOffer[]> => {
      const { data, error } = await supabase
        .from('job_offers')
        .select('*')
        .eq('is_active', true)
        .order('display_order', { ascending: true });

      if (error) {
        console.error('Erreur lors de la récupération des offres d\'emploi:', error);
        throw error;
      }

      return data || [];
    },
  });
};
